import styled from "styled-components";

export const Zone = styled.div`
  width: 100%;
  height: 110px;
  display: flex;
  border-radius: 5px;
  align-items: center;
  justify-content: center;
`;
